import PathwayCandidatesContainer from './pathway_candidates_container';

const PathwayCandidates = PathwayCandidatesContainer;
export default PathwayCandidates;
